module.exports = __webpack_public_path__ + "static/media/swapNav.06e6663e.svg";